import { render, staticRenderFns } from "./Tours.vue?vue&type=template&id=aece56f8&scoped=true&"
import script from "./Tours.vue?vue&type=script&lang=js&"
export * from "./Tours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aece56f8",
  null
  
)

export default component.exports